<template>
  <vs-row>
    <vs-col
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      vs-w="4"
    >
      <vs-button
        v-bind:disabled="isRegisteredBoat"
        class="button-w300-h300"
        color="primary"
        size="large"
        type="border"
        @click="nextTab(licenseCategory.BOAT)"
      >
        <span class="text-font-bolder">小型船舶免許の登録</span><br /><span
          class="text-small"
          >小型船舶免許を登録をします</span
        >
        <br /><br /><span v-if="isRegisteredBoat" class="text-small"
          >＊登録済みです</span
        >
      </vs-button>
    </vs-col>
    <vs-col
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      vs-w="4"
    >
      <vs-button
        v-bind:disabled="isRegisteredMarine"
        class="button-w300-h300"
        color="primary"
        size="large"
        type="border"
        @click="nextTab(licenseCategory.MARINE)"
        ><span class="text-font-bolder">海技士免許の登録</span><br /><span
          class="text-small"
          >航海士、機関士の登録をします</span
        ><br /><br /><span class="text-small" v-if="isRegisteredMarine"
          >＊登録済みです</span
        >
      </vs-button>
    </vs-col>
    <vs-col
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      vs-w="4"
    >
      <vs-button
        class="button-w300-h300"
        color="primary"
        size="large"
        type="border"
        @click="nextTab(licenseCategory.OTHERS)"
        ><span class="text-font-bolder">その他</span><br /><br
      /></vs-button>
    </vs-col>
  </vs-row>
</template>

<script>
import LicenseMixin from "@/mixins/LicenseMixin";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "enterpriseLicenseAdd"
);

export default {
  mixins: [LicenseMixin],
  data() {
    return {
      isRegisteredBoat: false,
      isRegisteredMarine: false,
      isRegisteredMarineEngineerLicense: false,
      isRegisteredMarineNavigatorLicense: false
    };
  },
  computed: {
    ...mapState({
      userLicense: state => state.userLicense
    }),
    now() {
      return false;
    }
  },
  watch: {
    userLicense() {
      this.verifyRegisteredLicense();
    }
  },
  methods: {
    ...mapActions(["setSelectedLicenseCategory"]),
    nextTab(licenseCategory) {
      this.setSelectedLicenseCategory(licenseCategory);
    },
    verifyRegisteredLicense() {
      this.userLicense.forEach(license => {
        let licenseNum = Number(license.license_type_id);
        // 小型船舶が登録済みかどうか
        if (this.isBoatLicense(licenseNum)) {
          this.isRegisteredBoat = true;
        }
        // 海技士(機関士)が登録済みかどうか
        if (this.isMarineEngineerLicense(licenseNum)) {
          this.isRegisteredMarineEngineerLicense = true;
        }
        // 海技士(航海士)が登録済みかどうか
        if (this.isMarineNavigatorLicense(licenseNum)) {
          this.isRegisteredMarineNavigatorLicense = true;
        }
      });

      if (
        this.isRegisteredMarineEngineerLicense &&
        this.isRegisteredMarineNavigatorLicense
      ) {
        this.isRegisteredMarine = true;
      }
    }
  }
};
</script>
<style lang="scss">
.text-font-bolder {
  font-weight: bolder;
}
.button-w300-h300 {
  width: 300px;
  height: 300px;
}
</style>
